export const isHorizontalRightIntersect = (source, target): boolean => {
	const isOverlap = target.left >= source.right &&
		target.i !== source.i &&
		(
			/* top edge outside, but bottom edge overlaps */
			(target.top >= source.top && target.top <= source.bottom) ||
			/* bottom edge outside, but top edge overlaps */
			(target.bottom <= source.bottom && target.bottom >= source.top) ||
			/* top edge outside top edge of target, bottom edge outside bottom edge of target (target equal to or taller than source, complete overlap)*/
			(target.top <= source.top && target.bottom >= source.bottom)
		);
	// console.log(`isRightOverLap (${source.pi?.item.sku ?? 'null'} -> ${target.pi?.item.sku ?? 'null'} = ${isOverlap})`, { source, target });
	return isOverlap;
};
